import React from 'react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import { AccountType } from '@cbgms/api'

export const AccountIcon: React.FC<{ accountType: AccountType }> = ({ accountType }) => {
  switch (accountType) {
    case AccountType.Business:
    case AccountType.Dealer:
      return <BusinessOutlinedIcon />
    case AccountType.Private:
      return <AccountCircleOutlinedIcon />
    default:
      return null
  }
}
